export const LONG_CLOSE_DURATION_DAYS = 30
export const MS_TIMEOUT_BEFORE_SHOW = 7000
export const COOKIE_NAME = 'advert_popin'
export const CONTENT_URI = '/api/popin/informations'
